import type {
    SavedBudgetRange,
    BudgetOption,
} from '@modules/build-hub-creator/api/types';
import { CUSTOM_BUDGET_OPTION } from '@modules/build-hub-creator/configs/constants';

/**
 * Find budget option given budget range
 */
export function mapBudgetMinMaxToRange(
    input: SavedBudgetRange,
    options: BudgetOption[]
): BudgetOption {
    // Find the custom budget option from the provided options array
    // (it might have key 'custom' from backend or 'budget_custom' from frontend constant)
    const customOption =
        options.find(
            (opt) =>
                opt.key === 'custom' ||
                opt.key === 'budget_custom' ||
                opt.key === CUSTOM_BUDGET_OPTION.key
        ) || CUSTOM_BUDGET_OPTION;

    // If min === max and both are > 0, this is a custom budget
    // (custom budgets are stored with both min and max set to the same value)
    // We check this first to ensure custom budgets are correctly identified
    if (
        typeof input.min === 'number' &&
        typeof input.max === 'number' &&
        input.min === input.max &&
        input.min > 0
    ) {
        return customOption;
    }

    // bounded range
    const containedMatch = options.find((opt) => {
        if (typeof opt.min === 'undefined' || typeof opt.max === 'undefined')
            return false;
        return opt.min <= input.min && opt.max >= input.max;
    });
    if (containedMatch) return containedMatch;

    // Unbounded match
    const unboundedMatch = options.find((opt) => {
        if (typeof opt.min !== 'undefined' && typeof opt.max === 'undefined') {
            return opt.min <= input.min;
        }

        if (typeof opt.max !== 'undefined' && typeof opt.min === 'undefined') {
            return opt.max >= input.max;
        }

        return false;
    });
    if (unboundedMatch) return unboundedMatch;

    return customOption;
}
